import api from '@pixelunion/shopify-theme-api';

window.api = api;
